import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHero from "@/components/PageHero";
import { Container, GoldButton, AdvertBadge } from "@/components/shared";

export default function Advertise() {
  const [slots, setSlots] = useState([]);
  useEffect(() => {
    api.get("/adslots").then((r) => setSlots(r.data));
  }, []);

  return (
    <div>
      <PageHero
        kicker="Advertise · The media kit"
        title="Four quiet berths across the crossing"
        intro="Made in Boston carries advertising the way a harbour office carries notices — plainly, and clearly labelled. Every paid surface is marked ‘Advert’ or ‘Paid listing’, so readers always know what they are looking at."
      >
        <GoldButton as="link" to="/contact">Enquire about a berth</GoldButton>
      </PageHero>

      <section className="py-16 sm:py-24">
        <Container>
          <div className="grid md:grid-cols-2 gap-8">
            {slots.map((s) => (
              <div key={s.slot_id} data-testid={`ad-kit-${s.slot_id}`} className="bg-[#FFFAF3] border border-[#D6D3CB] p-8 hover:border-[#CDA434] transition-colors">
                <div className="flex items-center justify-between mb-4">
                  <span className="font-mono text-xs text-[#505A68]">{s.slot_id}</span>
                  <AdvertBadge label={s.label} />
                </div>
                <h3 className="font-serif text-xl text-[#1E1E2F] mb-3">{slotTitle(s.slot_id)}</h3>
                <p className="font-sans text-base text-[#1B2430] leading-relaxed">{s.house_copy}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 max-w-3xl bg-[#1E1E2F] text-[#FFFAF3] p-10 border-t-2 border-[#CDA434]">
            <h2 className="font-serif text-2xl mb-4">Our terms, plainly</h2>
            <ul className="space-y-3 font-sans text-base text-[#FFFAF3]/80 leading-relaxed">
              <li>· Adverts are always labelled and kept clear of the 1630 story, About, Privacy, and Terms pages.</li>
              <li>· We favour makers, civic partners, and honest local firms over anything that jars with the crossing.</li>
              <li>· This is an independent project; an advert here is not an endorsement by any authority.</li>
            </ul>
            <div className="mt-8">
              <GoldButton as="link" to="/contact">Talk to us about advertising</GoldButton>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
}

function slotTitle(id) {
  return {
    "home.harbour": "Crossing of the week — homepage",
    "rail.made": "Right rail — the Made directory",
    "card.inline": "In-grid card — the Made directory",
    "visit.foot": "Itinerary strip — Stump to Common",
  }[id] || id;
}
